/**
* @file: 号码搜索结果
* @author: wence
*/

import React, {PureComponent} from 'react';
import PropType from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Loading from '../../components/Spin';
import SearchBar from '../../components/searchBar';
import {rcAjax, bAntiBotSend} from '../../util';

import {getNumberSearchResult} from '../../actions/numberAuthAction';

import './index.less';

const statusEnum = {
    normal: 0,
    abnormal: 400
};

const authEnum = {
    default: 0,
    done: 4
};

const imageUrl = '/xiapi/api/v1/phone/captcha';
const paramPage = 'request_page';
class NumberSearch extends PureComponent {
    static propTypes = {
        match: PropType.object,
        getNumberSearchResult: PropType.func,
        getCaptchaImage: PropType.func,
        numberSearchResult: PropType.object,
        capgchaImage: PropType.any
    }

    constructor(props) {
        super(props);

        this.state = {
            searchValue: '',
            reloadImage: imageUrl,
            isLoadingMore: false,
            isLoading: false,
            isValidate: false
        };

        if (this.isPC()) {
            const keywords = this.props.match.params.keywords;

            location.href = '/haoma/search?search=' + keywords;
        }

        this.renderResultItem = this.renderResultItem.bind(this);
        this.renderResult = this.renderResult.bind(this);
        this.scrollLoading = this.scrollLoading.bind(this);
        this.vilidateValue = this.vilidateValue.bind(this);
    }

    async componentDidMount() {
        const keywords = this.props.match.params.keywords;
        this.setState({searchValue: keywords, isLoading: true});

        await this.props.getNumberSearchResult({search: keywords, [paramPage]: 1});

        this.setState({isLoading: false});
        window.addEventListener('scroll', this.scrollLoading);
    }

    vilidateValue(e) {
        e.preventDefault();
        const value = (this.input.value || '').trim();

        if (value === '') {
            return;
        }

        const numberSearchResult = this.props.numberSearchResult || {};
        rcAjax(
            'POST',
            '/xiapi/api/v1/phone/verifty',
            {},
            {
                id: numberSearchResult.params && numberSearchResult.params.key_id,
                captcha: value
            },
            data => {
                if (data.data
                    && data.data.status === 0
                    && data.data.data && data.data.data.status) {
                    this.setState({isLoading: true});

                    if (numberSearchResult.params && numberSearchResult.params.request_page > 1) {
                        document.documentElement.scrollTop = document.body.scrollTop = 0;
                    }
                    this.props.getNumberSearchResult({
                        search: this.state.searchValue,
                        [paramPage]: 1
                    })
                        .then(() => {
                            this.setState({isLoading: false});
                        }).catch(() => {
                            this.setState({isLoading: false});
                        });
                }
                else if (this.input) {
                    this.input.value = '';
                }
                this.setState(() => ({reloadImage: imageUrl + '?t=' + Date.now()}));
            });
    }

    uploadData() {
        try {
            bAntiBotSend();
        }
        catch (e) {
            return;
        }
    }

    async scrollLoading() {
        if (this.loading) {
            const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            const clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
            const {match, numberSearchResult} = this.props;
            const keywords = match.params.keywords;
            const curPage = Number(numberSearchResult.curr_page) || 1;
            const total = numberSearchResult.total;
            const perPage = numberSearchResult.per_page;
            const maxPage = Math.ceil(total / perPage);
            // 大于300条以后无限滚动
            const isMore = total >= 300 ? true : curPage < maxPage;

            if (
                (clientHeight + 100) + scrollTop >= this.loading.offsetTop
                && !this.state.isLoadingMore
                && isMore
            ) {
                this.uploadData();
                this.setState({isLoadingMore: true});

                await this.props.getNumberSearchResult({
                    search: keywords,
                    [paramPage]: curPage + 1,
                    isMore: true,
                    position: numberSearchResult.params
                        && numberSearchResult.params.position
                });
                this.setState({isLoadingMore: false});
            }
        }
    }

    renderPhone = item => {
        // return (
        //     (item.phone
        //         .map(item =>
        //             item.label && item.label !== item.number
        //                 ? `${item.label} ${item.number}`
        //                 : item.number) || []).join('、')
        // );

        const length = (item.phone || []).length;
        return (item.phone || []).map((item, index) => {
            if (item.label && item.label !== item.number) {

                return index === 0
                    ? <span key={index}>{`${item.label} ${item.number}`}</span>
                    : <div key={index}>{`${item.label} ${item.number}`}</div>;
            }
            else {
                return length - 1 === index ? item.number : item.number + '、';
            }
        });
    }

    renderResultItem(item, index) {
        return (
            <div key={index} className="result-search-item">
                <div className="result-search-icon">
                    <img src={item.logourl
                        ? item.logourl
                        : require('../../asset/svg/icon_phone.svg')}
                    style={item.logourl ? {borderRadius: '50%'} : null}
                    alt="phone-icon" />
                </div>
                <div className="result-search-title">
                    <span className="result-search-title-h1">{item && item.name}</span>
                    {authEnum.done === (item && item.status)
                        && <span className="result-search-title-auth">
                            <img src={require('../../asset/svg/icon_yirenzheng.svg')} alt="auth" />
                            <span>已通过百度安全号码验证</span>
                        </span>}
                    {!!item && !!item.phone && item.phone.length > 0
                        && <span className="result-search-title-h2">号码：
                            <span>{this.renderPhone(item)}</span>
                        </span>}
                    {!!item && !!item.address
                        && <span className="result-search-title-h2">
                            地址：<span>{item.address}</span>
                        </span>}
                </div>
            </div>
        );
    }

    renderNoResult() {
        const numberSearchResult = this.props.numberSearchResult || {};

        if (this.state.isLoading) {
            return null;
        }

        if (numberSearchResult.list
            && (numberSearchResult.list.length > 0 || !!numberSearchResult.list.locate)
        ) {
            return null;
        }

        return (
            <div className="no-result">
                <img src={require('../../asset/svg/pic_yanzheng.svg')} alt="warning" />
                <p>抱歉，无该内容信息</p>
            </div>
        );
    }

    renderValidation() {
        if (this.state.isLoading) {
            return null;
        }

        return (
            <div className="verification">
                <img src={require('../../asset/svg/pic_yanzheng.svg')} alt="warning" />
                <p>请验证一下，我不是机器人</p>
                <div className="verification-img"
                    onClick={() => {
                        this.setState(() => ({reloadImage: imageUrl + '?t=' + Date.now()}));
                    }}>
                    {this.state.reloadImage
                        && <img src={this.state.reloadImage} alt="warning" />}
                    <span>刷新验证码</span>
                </div>
                <div className="verification-input">
                    <form onSubmit={this.vilidateValue}>
                        <input placeholder="请输入验证码" ref={input => this.input = input} type="text" />
                    </form>
                </div>
                <div onClick={this.vilidateValue} className="verification-btn">
                    验证
                </div>
            </div>
        );
    }

    renderResult() {
        const numberSearchResult = this.props.numberSearchResult;

        if (this.state.isLoading) {
            return null;
        }

        if (numberSearchResult.status !== statusEnum.normal) {
            return null;
        }

        if (numberSearchResult.list && ('status' in numberSearchResult.list)) {
            const numberSearchResultList = numberSearchResult.list || {};
            const locate = numberSearchResultList.locate;
            if (!locate) {
                return null;
            }

            return this.renderResultItem({
                name: locate,
                phone: [{number: this.state.searchValue, label: this.state.searchValue}]
            });
        }

        if (numberSearchResult.list.length <= 0) {
            return null;
        }
        return (
            <div>
                {numberSearchResult.list
                    && numberSearchResult.list.map(this.renderResultItem)}

                <div ref={loading => this.loading = loading} className="result-loading">
                    {this.state.isLoadingMore && <div className="loding-btn"></div>}
                </div>
            </div>
        );
    }

    render() {
        const searchValue = this.state.searchValue;
        const numberSearchResult = this.props.numberSearchResult || {};
        return (
            <div className="number-search-result">
                <a href="/m/haoma/search">
                    <div className="result-search">
                        <SearchBar
                            isShowClear={false}
                            disabled
                            value={searchValue} />
                    </div>
                </a>
                <div className="result-search-container">
                    {this.state.isLoading && <Loading />}
                    {!numberSearchResult.is_auth && this.renderNoResult()}
                    {!numberSearchResult.is_auth && numberSearchResult.status === statusEnum.normal
                        && this.renderResult()}
                    {!!numberSearchResult.is_auth && this.renderValidation()}
                </div>
            </div>
        );
    }
}

export default connect(
    state => ({numberSearchResult: state.numberSearchResult}),
    dispatch => bindActionCreators({getNumberSearchResult}, dispatch)
)(NumberSearch);



// WEBPACK FOOTER //
// ./src/containers/numberSearch/searchResult.js